import(/* webpackMode: "eager" */ "/app/packages/frontend/app/(site)/error.tsx");
